"use strict";
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GameObjectSystemManager = void 0;
var lodash_1 = require("lodash");
/*
 * Manages the gameObjects that each systems track
 * and vice versa
 */
var GameObjectSystemManager = /** @class */ (function () {
    function GameObjectSystemManager() {
        /*
         * Maps gameObject type to managing systems
         */
        this.gameObjectManagingSystems = new Map();
        /*
         * Maps the system type to the gameObjects it manages
         * This is essentially the inverse of gameObjectManagingSystems
         */
        this.systemGameObjects = new Map();
    }
    GameObjectSystemManager.prototype.addSystem = function (s) {
        var e_1, _a;
        try {
            for (var _b = __values(s.getTargets()), _c = _b.next(); !_c.done; _c = _b.next()) {
                var gameObjectType = _c.value;
                var systemSet = this.gameObjectManagingSystems.get(gameObjectType);
                if (systemSet === undefined) {
                    this.gameObjectManagingSystems.set(gameObjectType, new Set([s]));
                }
                else {
                    systemSet.add(s);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    GameObjectSystemManager.prototype.addGameObject = function (c) {
        var e_2, _a;
        try {
            for (var _b = __values(this.getGameObjectManagingSystems(c)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var managingSystem = _c.value;
                var gameObjectSet = this.systemGameObjects.get(managingSystem.type);
                if (gameObjectSet === undefined) {
                    this.systemGameObjects.set(managingSystem.type, new Set([c]));
                }
                else {
                    gameObjectSet.add(c);
                }
                // Call this hook
                managingSystem.onTargetGameObjectEnter(c);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
    };
    GameObjectSystemManager.prototype.removeGameObject = function (c) {
        var e_3, _a;
        var _b;
        try {
            for (var _c = __values(this.getGameObjectManagingSystems(c)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var managingSystem = _d.value;
                // Call hook
                managingSystem.onTargetGameObjectExit(c);
                (_b = this.systemGameObjects.get(managingSystem.type)) === null || _b === void 0 ? void 0 : _b.delete(c);
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_3) throw e_3.error; }
        }
    };
    /*
     * Gets all the systems that manage this given gameObject
     */
    GameObjectSystemManager.prototype.getGameObjectManagingSystems = function (c) {
        var _this = this;
        return (0, lodash_1.flatten)(c
            .getAllInheritedTypes()
            .map(function (gameObjectType) {
            return Array.from(_this.gameObjectManagingSystems.get(gameObjectType) || []);
        }));
    };
    /*
     * Gets all gameObjects managed by a given system
     */
    GameObjectSystemManager.prototype.getSystemGameObjects = function (systemType) {
        return Array.from(this.systemGameObjects.get(systemType) || []);
    };
    return GameObjectSystemManager;
}());
exports.GameObjectSystemManager = GameObjectSystemManager;
